/*
 * @Author: lzs
 * @Date: 2026-01-27 15:02:02
 * @LastEditors: lzs
 * @LastEditTime: 2026-01-27 16:54:24
 * @FilePath: \ly-vr\src\router\index.ts
 * @Description: 
 */
import { RouteRecordRaw, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/pano/view/187214879063543808',
  },
  {
    path: '/pano/view/:recordId',
    component: () => import('@/views/pano/view.vue'),
    name: 'panoView',
    meta: {
      title: 'VR全景展示'
    }
  },
  // {
  //   path: '/index',
  //   component: () => import('@/views/index/index.vue'),
  //   name: 'index',
  // },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    name: 'webLogin',
    meta: {
      title: '登录'
    }
  },
  {
    path: '/preview',
    component: () => import('@/views/preview/preview.vue'),
  },
  {
    path: '/404',
    component: () => import('@/views/container/404.vue'),
    name: '404',
  },
  
  {
    path: '/pano/message',
    component: () => import('@/views/pano/message/index.vue'),
    name: 'panoMessage',
    meta: {
      title: 'VR全景留言咨询'
    }
  },
  {
    path: '/album/view/:recordId',
    component: () => import('@/views/album/view.vue'),
    name: 'albumView',
    meta: {
      title: '电子画册'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(import.meta.env.VITE_PUBLIC_PATH),
  routes,
});


// 全局前置守卫，用于设置页面标题
router.beforeEach((to, from, next) => {
  // 如果路由对象中有标题属性，则设置文档标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + '-' + import.meta.env.VITE_APP_TITLE
  }
  next() // 必须调用 next() 来 resolve 这个钩子
})

export default router;
